import React from 'react';

const Loading = () => (
  <div style={{
    height: '100%',
    width: '100%',
    textAlign: 'center',
    margin: '70px auto',
  }}
  >
    <span className="segment-spinner" />
  </div>
);

export default Loading;
